import { WebAppProject } from "../../../../../library-js/web-app/project/WebAppProject";
import { ExportSettings } from "./exporting/ExportSettings";

export class AudioEditorProject extends WebAppProject
{
  audioBuffer:AudioBuffer;
  exportSettings = new ExportSettings();
  
  serialize():Promise<Int8Array>
  {
    return Promise.resolve( null );
  }

  deserialize( data:Int8Array ):Promise<void>
  {
    return Promise.resolve();
  }
}